import React from "react";
import HeadImg from "../../images/icons/ico_people3.png";
import {
  BrowserView,
  MobileOnlyView,
  TabletView,
  isIOS,
} from "react-device-detect";

function Present() {
  return (
    <>
      <BrowserView>
        <div className={isIOS ? "IpadViewNone" : "present-box"}>
          <div className="present-box-sub">
            <h4>
              <img src={HeadImg} alt="HeadImg" className="HeadImg" /> Derian
              House Children’s Hospice: 2023 - Present
            </h4>
            <p>
              Since choosing Derian House Children’s Hospice as our charity
              partner in 2023, our team has been working hard to raise funds and
              awareness for the incredible support they provide to children and
              families facing life-limiting conditions. We're proud to have
              raised an amazing £15,000 so far, and we’re aiming even
              higher—with a target to grow this total by June 2025.​
            </p>
            <p>
              To reach this milestone, our colleagues have taken part in a whole
              host of fun, energetic, and heartwarming fundraising events. From
              our Company Charity Football Match, where teams from across the
              business battled it out on the pitch, to brave individuals
              tackling the muddy challenge of Tough Mudder, everyone has gone
              above and beyond to show their support.​
            </p>
            <p>
              We’ve also kept the momentum going with a mix of much-loved
              events, including bake sales, bingo, a memorable Golf Day, and
              festive favourites like our Christmas Makers Market and raffle.
            </p>
          </div>
        </div>
      </BrowserView>
      <TabletView>
        <div className="present-box">
          <div className="present-box-sub">
            <h4>
            <p>
              Since choosing Derian House Children’s Hospice as our charity
              partner in 2023, our team has been working hard to raise funds and
              awareness for the incredible support they provide to children and
              families facing life-limiting conditions. We're proud to have
              raised an amazing £15,000 so far, and we’re aiming even
              higher—with a target to grow this total by June 2025.​
            </p>
            <p>
              To reach this milestone, our colleagues have taken part in a whole
              host of fun, energetic, and heartwarming fundraising events. From
              our Company Charity Football Match, where teams from across the
              business battled it out on the pitch, to brave individuals
              tackling the muddy challenge of Tough Mudder, everyone has gone
              above and beyond to show their support.​
            </p>
            <p>
              We’ve also kept the momentum going with a mix of much-loved
              events, including bake sales, bingo, a memorable Golf Day, and
              festive favourites like our Christmas Makers Market and raffle.
            </p>
              <img src={HeadImg} alt="HeadImg" className="HeadImg" /> Derian
              House Children’s Hospice: 2023 - Present
            </h4>
          </div>
          <div className="inspire-chorley-sub"></div>
        </div>
      </TabletView>
      <MobileOnlyView>
        <div className="present-box">
          <div className="present-box-sub">
            <h4>
              <img src={HeadImg} alt="HeadImg" className="HeadImg" /> Derian
              House Children’s Hospice: 2023 - Present
            </h4>
            <p>
              Since choosing Derian House Children’s Hospice as our charity
              partner in 2023, our team has been working hard to raise funds and
              awareness for the incredible support they provide to children and
              families facing life-limiting conditions. We're proud to have
              raised an amazing £15,000 so far, and we’re aiming even
              higher—with a target to grow this total by June 2025.​
            </p>
            <p>
              To reach this milestone, our colleagues have taken part in a whole
              host of fun, energetic, and heartwarming fundraising events. From
              our Company Charity Football Match, where teams from across the
              business battled it out on the pitch, to brave individuals
              tackling the muddy challenge of Tough Mudder, everyone has gone
              above and beyond to show their support.​
            </p>
            <p>
              We’ve also kept the momentum going with a mix of much-loved
              events, including bake sales, bingo, a memorable Golf Day, and
              festive favourites like our Christmas Makers Market and raffle.
            </p>
          </div>
        </div>
      </MobileOnlyView>

      <BrowserView>
        <div className={isIOS ? "IpadViewNone" : "present-box"}>
          <div className="present-box-sub">
            <h4>
              <img src={HeadImg} alt="HeadImg" className="HeadImg" /> Mind and
              Dementia UK 2021 - 2023
            </h4>
            <p>
              Between 2021 and 2023, Product Care Group proudly supported Mind
              and Dementia UK, two charities that are close to the hearts of
              many of our colleagues. Through a variety of fundraising
              initiatives, we collectively raised an incredible £10,000 to help
              support mental health services and those affected by dementia
              across the UK.​
            </p>
            <p>
              One of the standout moments was our team challenge to ‘Walk a
              Marathon’, where a dedicated group of colleagues walked the full
              26.2 miles along the stunning Llyn Peninsula coastal path, from
              Llanbedrog to Aberdaron. It was a physically demanding but deeply
              rewarding experience, bringing people together in support of a
              great cause.​
            </p>
            <p>
              In addition to the marathon walk, our teams got creative and
              involved with a wide range of fundraising activities, including
              coffee mornings, bake sales, and a huge Christmas raffle. Several
              colleagues also went the extra mile literally by running in
              individual marathon and half-marathon events across the country.​{" "}
            </p>
          </div>
        </div>
      </BrowserView>
      <TabletView>
        <div className="present-box">
          <div className="present-box-sub">
            <h4>
              <p>
                Between 2021 and 2023, Product Care Group proudly supported Mind
                and Dementia UK, two charities that are close to the hearts of
                many of our colleagues. Through a variety of fundraising
                initiatives, we collectively raised an incredible £10,000 to
                help support mental health services and those affected by
                dementia across the UK.​
              </p>
              <p>
                One of the standout moments was our team challenge to ‘Walk a
                Marathon’, where a dedicated group of colleagues walked the full
                26.2 miles along the stunning Llyn Peninsula coastal path, from
                Llanbedrog to Aberdaron. It was a physically demanding but
                deeply rewarding experience, bringing people together in support
                of a great cause.​
              </p>
              <p>
                In addition to the marathon walk, our teams got creative and
                involved with a wide range of fundraising activities, including
                coffee mornings, bake sales, and a huge Christmas raffle.
                Several colleagues also went the extra mile literally by running
                in individual marathon and half-marathon events across the
                country.​{" "}
              </p>
              <img src={HeadImg} alt="HeadImg" className="HeadImg" /> Mind and
              Dementia UK 2021 - 2023
            </h4>
          </div>
          <div className="inspire-chorley-sub"></div>
        </div>
      </TabletView>
      <MobileOnlyView>
        <div className="present-box">
          <div className="present-box-sub">
            <h4>
              <img src={HeadImg} alt="HeadImg" className="HeadImg" /> Mind and
              Dementia UK 2021 - 2023
            </h4>
            <p>
              Between 2021 and 2023, Product Care Group proudly supported Mind
              and Dementia UK, two charities that are close to the hearts of
              many of our colleagues. Through a variety of fundraising
              initiatives, we collectively raised an incredible £10,000 to help
              support mental health services and those affected by dementia
              across the UK.​
            </p>
            <p>
              One of the standout moments was our team challenge to ‘Walk a
              Marathon’, where a dedicated group of colleagues walked the full
              26.2 miles along the stunning Llyn Peninsula coastal path, from
              Llanbedrog to Aberdaron. It was a physically demanding but deeply
              rewarding experience, bringing people together in support of a
              great cause.​
            </p>
            <p>
              In addition to the marathon walk, our teams got creative and
              involved with a wide range of fundraising activities, including
              coffee mornings, bake sales, and a huge Christmas raffle. Several
              colleagues also went the extra mile literally by running in
              individual marathon and half-marathon events across the country.​{" "}
            </p>
          </div>
        </div>
      </MobileOnlyView>
    </>
  );
}

export default Present;
